import { z } from 'zod'
import { PointStatus } from '@library/enums'
import { dateValueSchema } from './date-value'

/** 點數明細資料 Schema */
export const pointDetailSchema = z.object({
  /** 方案 id */
  id: z.string(),
  /** 方案名稱[英文] */
  englishName: z.string(),
  /** 方案名稱[簡體中文] */
  simplifiedName: z.string(),
  /** 方案名稱[繁體中文] */
  traditionalName: z.string(),
  /** 券號 */
  couponNo: z.string().nullable(),
  /** 點數效期 */
  expireTime: dateValueSchema
})

/** 點數編號明細資料 Schema */
export const pointNoDetailSchema = z.object({
  /** 點數編號 */
  pointNo: z.string(),
  /** 點數 */
  point: z.number()
})

/** 點數明細清單 Schema */
export const pointInfoDetailSchema = z.object({
  /** 狀態 */
  status: z.nativeEnum(PointStatus),
  /** 建立日期 */
  createTime: dateValueSchema,
  /** 明細 */
  detail: pointDetailSchema,
  /** 點數編號明細 */
  pointNoDetail: z.array(pointNoDetailSchema),
  /** 點數 */
  point: z.number()
})

/** 企業點數明細清單資料 Schema */
export const pointInfoSchema = z.object({
  /** 目前帳戶點數 */
  point: z.number(),
  /** 點數明細清單 */
  pointDetail: z.array(pointInfoDetailSchema)
})

export interface PointDetail extends z.infer<typeof pointDetailSchema> {}

export interface PointNoDetail extends z.infer<typeof pointNoDetailSchema> {}

export interface PointInfoDetail
  extends z.infer<typeof pointInfoDetailSchema> {}

export interface PointInfo extends z.infer<typeof pointInfoSchema> {}
